import createCache, { type StylisPlugin } from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
// eslint-disable-next-line @nx/enforce-module-boundaries
import '../../../../../tailwind.config.css';
import { PropsWithChildren } from 'react';

// Add layer to MUI styling, see tailwind.config.css for more information, mui layer has lower priority than tailwind layers
const wrapInLayer: (layerName: string) => StylisPlugin = (layerName) => (node) => {
  // if we're not at the root of a <style> tag, leave the tree intact
  if (node.parent) {
    return;
  }

  // if we're at the root, replace node with `@layer layerName { node }`
  const child = { ...node, parent: node, root: node };
  Object.assign(node, {
    children: [child],
    length: 6,
    parent: null,
    props: [layerName],
    return: '',
    root: null,
    type: '@layer',
    value: `@layer ${layerName}`,
  });
};

const cache = createCache({
  key: 'css',
  prepend: false,
  stylisPlugins: [wrapInLayer('mui')],
});

export const EmotionCacheProvider = ({ children }: PropsWithChildren) => (
  <CacheProvider value={cache}>{children}</CacheProvider>
);
